(() => {
  const toggle = (button) => {
    const root = button.closest('.swiper-thumb__container, .product__media-sticky, .product--thumbnail_slider, .product--thumbnail_slider__mobile, .main-product__container') || button.parentElement;
    if (!root) return;
    const extras = Array.from(root.querySelectorAll('.lvc-media-extra'));
    if (!extras.length) return;
    const willOpen = extras.some((item) => item.classList.contains('is-hidden'));
    extras.forEach((item) => item.classList.toggle('is-hidden', !willOpen));
    const count = button.dataset.moreCount || extras.length;
    button.textContent = willOpen ? 'Ver menos' : ('Ver ' + count + ' más');
    button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lvc-media-more]');
    if (button) toggle(button);
  });
})();